<div
  class="viewing-rows-container"
  tabindex="-1"
  (click)="toggleDropdown(); dropdownInput.focus()"
  (blur)="closeDropdown()">
  <div class="viewing-rows-label">Viewing</div>
  <div class="d-flex align-items-center">
    <div class="viewing-rows-value" #dropdownInput>
      {{ selectedRowCount() }}
    </div>
    <mat-icon class="viewing-rows-icon" [svgIcon]="'chevron-down'"></mat-icon>
  </div>
  <div class="viewing-rows-label">rows</div>
</div>
<div #dropdownContent class="rows-dropdown-content" [hidden]="!showDropdown()">
  @for (option of pageSizeOptions(); track option) {
    <div class="rows-dropdown-item" (click)="optionSelected(option)" (mousedown)="$event.preventDefault()">
      {{ option }}
    </div>
  }
</div>
